import { HttpService } from "@root/services/http";
import { ADMIN_GET_ACTIVITIES_ENDPOINT, ADMIN_GET_GRAPHES_DATA_ENDPOINT, ADMIN_GET_PENDING_TRANSACTIONS_ENDPOINT, ADMIN_GET_USER_TRANSACTION_ENDPOINT, ADMIN_GET_USER_USAGE_HISTORY_ENDPOINT, ADMIN_USER_DEACTIVATE_ENDPOINT, ADMIN_USER_REACTIVATE_ENDPOINT } from "../endPoints";
import { WEB_TABLES_MAX_LIMIT } from "@root/webConstants";
import { addQueryToUrl } from "@root/utils/helpers";

export class AdminDashboardServices extends HttpService {
    getGraphesData = async (baseAuthUrl: string, payload?: any): Promise<any> => {
        const baseUrl = `${baseAuthUrl}/${ADMIN_GET_GRAPHES_DATA_ENDPOINT}?user_interval=${payload?.user_interval}&sub_interval=${payload?.sub_interval}`
        try {
            const apiResponse = await this.get(baseUrl);
            return apiResponse
        } catch (error) {
            throw error;
        }
    }
    getActivities = async (baseAuthUrl: string, payload: any): Promise<any> => {
        const baseUrl = `${baseAuthUrl}/${ADMIN_GET_ACTIVITIES_ENDPOINT}?limit=${WEB_TABLES_MAX_LIMIT}`
        const url = addQueryToUrl(baseUrl, payload)
        try {
            const apiResponse = await this.get(url);
            return apiResponse
        } catch (error) {
            throw error;
        }
    }
    getPendingTransactions = async (baseAuthUrl: string, payload: any): Promise<any> => {
        const baseUrl = `${baseAuthUrl}/${ADMIN_GET_PENDING_TRANSACTIONS_ENDPOINT}?limit=${WEB_TABLES_MAX_LIMIT}`
        const url = addQueryToUrl(baseUrl, payload)
        try {
            const apiResponse = await this.get(url);
            return apiResponse
        } catch (error) {
            throw error;
        }
    }
    getUserUsageHistory = async (baseAuthUrl: string, { userId, query }: any): Promise<any> => {
        const baseUrl = `${baseAuthUrl}/${ADMIN_GET_USER_USAGE_HISTORY_ENDPOINT}/${userId}?limit=${WEB_TABLES_MAX_LIMIT}`
        const url = addQueryToUrl(baseUrl, query)
        try {
            const apiResponse = await this.get(url);
            return apiResponse
        } catch (error) {
            throw error;
        }
    }
    getUserTransactions = async (baseAuthUrl: string, { userId, query }: any): Promise<any> => {
        const baseUrl = `${baseAuthUrl}/${ADMIN_GET_USER_TRANSACTION_ENDPOINT}/${userId}?limit=${WEB_TABLES_MAX_LIMIT}`
        const url = addQueryToUrl(baseUrl, query)
        try {
            const apiResponse = await this.get(url);
            return apiResponse
        } catch (error) {
            throw error;
        }
    }
    deActivateUser = async (baseAuthUrl: string, { userId, reactivate }: any): Promise<any> => {
        const baseUrl = `${baseAuthUrl}/${reactivate ? ADMIN_USER_REACTIVATE_ENDPOINT : ADMIN_USER_DEACTIVATE_ENDPOINT}/${userId}`
        try {
            const apiResponse = await this.patch(baseUrl, {});
            return apiResponse
        } catch (error) {
            throw error;
        }
    }
}